module.exports = __webpack_public_path__ + "RobotoLight.ba14e5534c256efc08f2.ttf";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoLight.ttf
// module id = ../../../../../src/fonts/RobotoLight.ttf
// module chunks = 3